import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=bb3e22da&"
import script from "./InfoIcon.js?vue&type=script&lang=js&"
export * from "./InfoIcon.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb3e22da')) {
      api.createRecord('bb3e22da', component.options)
    } else {
      api.reload('bb3e22da', component.options)
    }
    module.hot.accept("./InfoIcon.vue?vue&type=template&id=bb3e22da&", function () {
      api.rerender('bb3e22da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/InfoIcon/InfoIcon.vue"
export default component.exports